import React from 'react';



type Props = {
  className?: string;
}
export const ArrowDownVector: React.FC<Props> = ({ className }) => {
  return (
    <svg width = '24' height = '24' viewBox = '0 0 24 24' fill = 'none' xmlns = 'http://www.w3.org/2000/svg'>
      <path fill = 'currentColor' d = 'M12.744 15.1716C12.3467 15.614 11.6533 15.614 11.256 15.1716L7.43602 10.9182C6.85786 10.2744 7.31474 9.25 8.18002 9.25L15.82 9.25C16.6853 9.25 17.1421 10.2744 16.564 10.9182L12.744 15.1716Z' />
    </svg>
  );
};
